import client from './client';

export async function listPassportCandidates(params) {
  const { data } = await client.get('/passport-requests/candidates', { params });
  return data.data;
}

export async function createPassportRequest(payload) {
  const { data } = await client.post('/passport-requests', payload);
  return data.data;
}

export async function listPassportRequests(params) {
  const { data } = await client.get('/passport-requests', { params });
  return data.data;
}

export async function passportHistory(candidateId) {
  const { data } = await client.get(`/passport-requests/history/${candidateId}`);
  return data.data;
}

export async function approvePassportRequest(id) {
  const { data } = await client.post(`/passport-requests/${id}/approve`);
  return data.data;
}

export async function rejectPassportRequest(id, review_remarks) {
  const { data } = await client.post(`/passport-requests/${id}/reject`, { review_remarks });
  return data.data;
}

export async function listPassportReasons(params) {
  const { data } = await client.get('/passport-reasons', { params });
  return data.data;
}

export async function createPassportReason(payload) {
  const { data } = await client.post('/passport-reasons', payload);
  return data.data;
}

export async function updatePassportReason(id, payload) {
  const { data } = await client.put(`/passport-reasons/${id}`, payload);
  return data.data;
}

export async function deletePassportReason(id) {
  await client.delete(`/passport-reasons/${id}`);
}

export async function listCollectedPassports(params) {
  const { data } = await client.get('/passport-requests/collected', { params });
  return data.data;
}
